import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ObtenerPreguntasFrecuentes from '../functions/ObtenerPreguntasFrecuentes';
import PreguntaFrecuenteTabla from '../types/PreguntaFrecuenteTabla';
import { DragHandleOutlined } from '@mui/icons-material';


interface ListarPreguntasFrecuentesProps {
    defaultItemsPerPage?: number;
    handleEdit: (preguntafrecuente: PreguntaFrecuenteTabla) => void;
    handleDelete: (preguntafrecuente: PreguntaFrecuenteTabla) => void;
    handleAdd: () => void
}

export const ListarPreguntasFrecuentes: React.FC<ListarPreguntasFrecuentesProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [preguntasFrecuentes, setPreguntasFrecuentes] = useState<PreguntaFrecuenteTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchPreguntasFrecuentes = async () => {
      try {
        const data = await ObtenerPreguntasFrecuentes();
        setPreguntasFrecuentes(data.preguntasfrecuentes);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener las preguntas frecuentes:' + err);
        setLoading(false);
      }
    };

    fetchPreguntasFrecuentes();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'pregunta', label: 'PREGUNTA', align: 'left' as const },
    { key: 'orden', label: 'POSICION', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dado_de_baja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (preguntafrecuente: PreguntaFrecuenteTabla) => {
    handleEdit(preguntafrecuente);
  };

  const handleDeleteLocal = (preguntafrecuente: PreguntaFrecuenteTabla) => {
    handleDelete(preguntafrecuente);
  };

  const handleCredencialLocal = (preguntafrecuente: PreguntaFrecuenteTabla) => {
    console.log('Mostrar credencial', preguntafrecuente);
  }

  const handleUbicationLocal = (preguntafrecuente: PreguntaFrecuenteTabla) => {
    console.log('Mostrar ubicacion', preguntafrecuente);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Preguntas Frecuentes cargadas</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nueva Pregunta Frecuente</button>
        </div>
      </div>
      <Tabla columns={columns} data={preguntasFrecuentes} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};